(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Lab-Grown-Eme-Gems-Guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-lge-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-lge-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-lge-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-lge-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["april-birthstone-diamond"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-apr-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-apr-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-apr-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-apr-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Aries",f:"Sergei Rachmaninoff",t:"Emotional grandeur"},{day:2,z:"Aries",f:"Hans Christian Andersen",t:"Dark fairy tales"},
{day:3,z:"Aries",f:"Marlon Brando",t:"Method mastery"},{day:4,z:"Aries",f:"Maya Angelou",t:"Unbowed voice"},
{day:5,z:"Aries",f:"Pharrell Williams",t:"Creative optimism"},{day:6,z:"Aries",f:"Raphael",t:"Renaissance perfection"},
{day:7,z:"Aries",f:"Jackie Chan",t:"Fearless showman"},{day:8,z:"Aries",f:"Kofi Annan",t:"Diplomatic grace"},
{day:9,z:"Aries",f:"Charles Baudelaire",t:"Beautiful darkness"},{day:10,z:"Aries",f:"Omar Sharif",t:"Cinematic magnetism"},
{day:11,z:"Aries",f:"Ethel Kennedy",t:"Enduring resolve"},{day:12,z:"Aries",f:"David Letterman",t:"Subversive wit"},
{day:13,z:"Aries",f:"Thomas Jefferson",t:"Founding intellect"},{day:14,z:"Aries",f:"Sarah Michelle Gellar",t:"Fierce determination"},
{day:15,z:"Aries",f:"Leonardo da Vinci",t:"Universal genius"},{day:16,z:"Aries",f:"Charlie Chaplin",t:"Silent eloquence"},
{day:17,z:"Aries",f:"Victoria Beckham",t:"Relentless reinvention"},{day:18,z:"Aries",f:"Kourtney Kardashian",t:"Brand architect"},
{day:19,z:"Aries",f:"Maria Sharapova",t:"Competitive fire"},{day:20,z:"Taurus",f:"Jessica Lange",t:"Fearless depth"},
{day:21,z:"Taurus",f:"Queen Elizabeth II",t:"Steady reign"},{day:22,z:"Taurus",f:"Jack Nicholson",t:"Unhinged brilliance"},
{day:23,z:"Taurus",f:"William Shakespeare",t:"Infinite invention"},{day:24,z:"Taurus",f:"Barbra Streisand",t:"Total commitment"},
{day:25,z:"Taurus",f:"Al Pacino",t:"Explosive intensity"},{day:26,z:"Taurus",f:"Channing Tatum",t:"Athletic charm"},
{day:27,z:"Taurus",f:"Ulysses S. Grant",t:"Quiet resolve"},{day:28,z:"Taurus",f:"Jay Leno",t:"Tireless showman"},
{day:29,z:"Taurus",f:"Duke Ellington",t:"Elegant innovation"},{day:30,z:"Taurus",f:"Gal Gadot",t:"Warrior grace"}];
var Z={Aries:{d:"Mar 21 \u2013 Apr 19",e:"Fire",s:"\u2648",x:"Diamond amplifies Aries\u2019 natural boldness and fearless energy. A stone whose very name means \u201cinvincible\u201d paired with the sign that charges forward first \u2014 it\u2019s the most naturally aligned birthstone-sign combination in the zodiac."},
Taurus:{d:"Apr 20 \u2013 May 20",e:"Earth",s:"\u2649",x:"Diamond resonates with Taurus\u2019s deep appreciation for lasting beauty, material quality, and relationships built to endure. The stone\u2019s permanence mirrors the Bull\u2019s commitment to what truly matters."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-apr-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-apr-cal-btn';b.type='button';b.setAttribute('aria-label','April '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Taurus'){var dot=document.createElement('span');dot.className='ta-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-apr-cal-title'),eE=document.getElementById('ts-apr-cal-empty'),eC=document.getElementById('ts-apr-cal-card'),
eY=document.getElementById('ts-apr-cc-eye'),eB=document.getElementById('ts-apr-cc-badge'),eBS=document.getElementById('ts-apr-cc-bs'),
eZL=document.getElementById('ts-apr-cc-zl'),eZT=document.getElementById('ts-apr-cc-zt'),eF=document.getElementById('ts-apr-cc-fn'),
eTr=document.getElementById('ts-apr-cc-trait'),eCta=document.getElementById('ts-apr-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your April Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>April '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='April '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>April '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">diamond</strong> \u2014 the hardest substance on Earth and the ultimate symbol of invincibility. As a '+d.z+' ('+z.d+'), diamond is especially aligned with your sign.';
eZL.textContent=d.z+' + Diamond';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop April '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["august-birthstone-peridot"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-aug-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-aug-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-aug-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-aug-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Leo",f:"Jerry Garcia",t:"Grateful wanderer"},{day:2,z:"Leo",f:"James Baldwin",t:"Unflinching witness"},
{day:3,z:"Leo",f:"Martha Stewart",t:"Domestic empire"},{day:4,z:"Leo",f:"Barack Obama",t:"Oratory precision"},
{day:5,z:"Leo",f:"Neil Armstrong",t:"One small step"},{day:6,z:"Leo",f:"Andy Warhol",t:"Pop provocateur"},
{day:7,z:"Leo",f:"Charlize Theron",t:"Brutal glamour"},{day:8,z:"Leo",f:"Roger Federer",t:"Effortless mastery"},
{day:9,z:"Leo",f:"Whitney Houston",t:"Voice of a generation"},{day:10,z:"Leo",f:"Antonio Banderas",t:"Passionate range"},
{day:11,z:"Leo",f:"Chris Hemsworth",t:"Heroic instinct"},{day:12,z:"Leo",f:"Erwin Schr\u00f6dinger",t:"Quantum paradox"},
{day:13,z:"Leo",f:"Alfred Hitchcock",t:"Master of suspense"},{day:14,z:"Leo",f:"Halle Berry",t:"Barrier breaker"},
{day:15,z:"Leo",f:"Napoleon Bonaparte",t:"Outsized ambition"},{day:16,z:"Leo",f:"Madonna",t:"Constant reinvention"},
{day:17,z:"Leo",f:"Robert De Niro",t:"Method intensity"},{day:18,z:"Leo",f:"Patrick Swayze",t:"Gritty grace"},
{day:19,z:"Leo",f:"Coco Chanel",t:"Elegance defined"},{day:20,z:"Leo",f:"Demi Lovato",t:"Resilient honesty"},
{day:21,z:"Leo",f:"Usain Bolt",t:"Lightning embodied"},{day:22,z:"Leo",f:"Claude Debussy",t:"Impressionist ear"},
{day:23,z:"Virgo",f:"Kobe Bryant",t:"Mamba mentality"},{day:24,z:"Virgo",f:"Dave Chappelle",t:"Unfiltered truth"},
{day:25,z:"Virgo",f:"Sean Connery",t:"Effortless authority"},{day:26,z:"Virgo",f:"Mother Teresa",t:"Radical compassion"},
{day:27,z:"Virgo",f:"Lyndon B. Johnson",t:"Legislative force"},{day:28,z:"Virgo",f:"Jack Black",t:"Chaotic energy"},
{day:29,z:"Virgo",f:"Michael Jackson",t:"Moonwalking legend"},{day:30,z:"Virgo",f:"Cameron Diaz",t:"Sunny presence"},
{day:31,z:"Virgo",f:"Maria Montessori",t:"Learning reimagined"}];
var Z={Leo:{d:"Jul 23 \u2013 Aug 22",e:"Fire",s:"\u264c",x:"Peridot\u2019s ancient title, \u201cgem of the sun,\u201d makes it a natural companion for the zodiac\u2019s solar sign. Both radiate warmth, generosity, and an instinct for the center of the room."},
Virgo:{d:"Aug 23 \u2013 Sep 22",e:"Earth",s:"\u264d",x:"Peridot\u2019s deep connection to the Earth\u2019s mantle and its reputation for clarity and renewal resonate with Virgo\u2019s grounded precision and constant drive toward self-improvement."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-aug-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-aug-cal-btn';b.type='button';b.setAttribute('aria-label','August '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Virgo'){var dot=document.createElement('span');dot.className='vi-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-aug-cal-title'),eE=document.getElementById('ts-aug-cal-empty'),eC=document.getElementById('ts-aug-cal-card'),
eY=document.getElementById('ts-aug-cc-eye'),eB=document.getElementById('ts-aug-cc-badge'),eBS=document.getElementById('ts-aug-cc-bs'),
eZL=document.getElementById('ts-aug-cc-zl'),eZT=document.getElementById('ts-aug-cc-zt'),eF=document.getElementById('ts-aug-cc-fn'),
eTr=document.getElementById('ts-aug-cc-trait'),eCta=document.getElementById('ts-aug-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your August Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>August '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='August '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>August '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">peridot</strong>, the gem of the sun. As a '+d.z+' ('+z.d+'), peridot is especially aligned with your sign.';
eZL.textContent=d.z+' + Peridot';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop August '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-diamond-gem-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-bd-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-bd-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-bd-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-bd-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blue-diamond-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-bld-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-bld-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-bld-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-bld-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champagne-diamond-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-chd-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-chd-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-chd-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-chd-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["december-birthstone-tanzanite"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-dec-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-dec-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-dec-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-dec-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
var DAYS=[
{day:1,z:"Sagittarius",f:"Woody Allen",t:"Neurotic genius"},{day:2,z:"Sagittarius",f:"Britney Spears",t:"Unstoppable"},{day:3,z:"Sagittarius",f:"Ozzy Osbourne",t:"Prince of darkness"},
{day:4,z:"Sagittarius",f:"Jay-Z",t:"Empire built"},{day:5,z:"Sagittarius",f:"Walt Disney",t:"Imagineered worlds"},{day:6,z:"Sagittarius",f:"Nick Park",t:"Clay genius"},
{day:7,z:"Sagittarius",f:"Tom Waits",t:"Beautiful wreckage"},{day:8,z:"Sagittarius",f:"Teri Hatcher",t:"Desperate charm"},{day:9,z:"Sagittarius",f:"Judi Dench",t:"Royal command"},
{day:10,z:"Sagittarius",f:"Emily Dickinson",t:"Reclusive fire"},{day:11,z:"Sagittarius",f:"Aleksandr Solzhenitsyn",t:"Truth against empire"},{day:12,z:"Sagittarius",f:"Frank Sinatra",t:"My way"},
{day:13,z:"Sagittarius",f:"Taylor Swift",t:"Eras defined"},{day:14,z:"Sagittarius",f:"Nostradamus",t:"Future glimpsed"},{day:15,z:"Sagittarius",f:"Nero",t:"Fiddled"},
{day:16,z:"Sagittarius",f:"Ludwig van Beethoven",t:"Deaf thunder"},{day:17,z:"Sagittarius",f:"Pope Francis",t:"Humble authority"},{day:18,z:"Sagittarius",f:"Brad Pitt",t:"Leading man"},
{day:19,z:"Sagittarius",f:"Edith Piaf",t:"No regrets"},{day:20,z:"Sagittarius",f:"Uri Geller",t:"Bent reality"},{day:21,z:"Sagittarius",f:"Samuel L. Jackson",t:"Every word counts"},
{day:22,z:"Capricorn",f:"Ralph Fiennes",t:"Controlled intensity"},{day:23,z:"Capricorn",f:"Emperor Akihito",t:"Quiet reign"},{day:24,z:"Capricorn",f:"Ava Gardner",t:"Old Hollywood"},
{day:25,z:"Capricorn",f:"Humphrey Bogart",t:"Here\u2019s looking"},{day:26,z:"Capricorn",f:"Mao Zedong",t:"Long march"},{day:27,z:"Capricorn",f:"Louis Pasteur",t:"Invisible saved"},
{day:28,z:"Capricorn",f:"Denzel Washington",t:"Commanding truth"},{day:29,z:"Capricorn",f:"Jude Law",t:"English gravity"},{day:30,z:"Capricorn",f:"Tiger Woods",t:"Green jacket"},
{day:31,z:"Capricorn",f:"Henri Matisse",t:"Color liberated"}];
var Z={Sagittarius:{d:"Nov 22 \u2013 Dec 21",e:"Fire",s:"\u2650",x:"Tanzanite\u2019s trichroic nature shows different colors from different perspectives. That quality mirrors Sagittarius\u2019s lifelong search for truth through exploration and shifting viewpoints."},
Capricorn:{d:"Dec 22 \u2013 Jan 19",e:"Earth",s:"\u2651",x:"Tanzanite\u2019s singular source and finite supply resonate with Capricorn\u2019s understanding of scarcity, discipline, and the value of things that cannot be manufactured or replaced."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-dec-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-dec-cal-btn';b.type='button';b.setAttribute('aria-label','December '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Capricorn'){var dot=document.createElement('span');dot.className='cp-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-dec-cal-title'),eE=document.getElementById('ts-dec-cal-empty'),eC=document.getElementById('ts-dec-cal-card'),
eY=document.getElementById('ts-dec-cc-eye'),eB=document.getElementById('ts-dec-cc-badge'),eBS=document.getElementById('ts-dec-cc-bs'),
eZL=document.getElementById('ts-dec-cc-zl'),eZT=document.getElementById('ts-dec-cc-zt'),eF=document.getElementById('ts-dec-cc-fn'),
eTr=document.getElementById('ts-dec-cc-trait'),eCta=document.getElementById('ts-dec-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your December Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>December '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='December '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>December '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">tanzanite</strong> (with zircon and turquoise as alternatives). As a '+d.z+' ('+z.d+'), tanzanite is especially aligned with your sign.';
eZL.textContent=d.z+' + Tanzanite';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop December '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["february-birthstone-amethyst"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-feb-rv').forEach(function(el){obs.observe(el);});

document.querySelectorAll('.ts-feb-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-feb-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});

var sL=document.querySelectorAll('.ts-feb-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});

var DAYS=[
{day:1,z:"Aquarius",f:"Harry Styles",t:"Magnetic vulnerability"},{day:2,z:"Aquarius",f:"Shakira",t:"Unstoppable rhythm"},
{day:3,z:"Aquarius",f:"Warsan Shire",t:"Poetic fire"},{day:4,z:"Aquarius",f:"Rosa Parks",t:"Quiet revolution"},
{day:5,z:"Aquarius",f:"Cristiano Ronaldo",t:"Relentless pursuit"},{day:6,z:"Aquarius",f:"Bob Marley",t:"Peaceful resistance"},
{day:7,z:"Aquarius",f:"Charles Dickens",t:"Social conscience"},{day:8,z:"Aquarius",f:"James Dean",t:"Restless soul"},
{day:9,z:"Aquarius",f:"Mia Farrow",t:"Quiet defiance"},{day:10,z:"Aquarius",f:"Laura Dern",t:"Fearless range"},
{day:11,z:"Aquarius",f:"Thomas Edison",t:"Relentless invention"},{day:12,z:"Aquarius",f:"Abraham Lincoln",t:"Unyielding conviction"},
{day:13,z:"Aquarius",f:"Peter Gabriel",t:"Sonic visionary"},{day:14,z:"Aquarius",f:"Valentine\u2019s Day",t:"Love\u2019s own date"},
{day:15,z:"Aquarius",f:"Galileo Galilei",t:"Defiant truth"},{day:16,z:"Aquarius",f:"The Weeknd",t:"After-dark artistry"},
{day:17,z:"Aquarius",f:"Michael Jordan",t:"Supreme dominance"},{day:18,z:"Aquarius",f:"Yoko Ono",t:"Radical imagination"},
{day:19,z:"Pisces",f:"Copernicus",t:"Rewriting the cosmos"},{day:20,z:"Pisces",f:"Rihanna",t:"Fearless reinvention"},
{day:21,z:"Pisces",f:"Nina Simone",t:"Searing truth"},{day:22,z:"Pisces",f:"George Washington",t:"Founding resolve"},
{day:23,z:"Pisces",f:"W.E.B. Du Bois",t:"Intellectual fire"},{day:24,z:"Pisces",f:"Steve Jobs",t:"Obsessive vision"},
{day:25,z:"Pisces",f:"George Harrison",t:"Quiet mystic"},{day:26,z:"Pisces",f:"Johnny Cash",t:"Dark authenticity"},
{day:27,z:"Pisces",f:"Elizabeth Taylor",t:"Untamed glamour"},{day:28,z:"Pisces",f:"Bernadette Peters",t:"Timeless sparkle"}];
var Z={Aquarius:{d:"Jan 20 \u2013 Feb 18",e:"Air",s:"\u2652",x:"Amethyst enhances Aquarius\u2019s visionary intellect with emotional clarity and grounding calm. The stone\u2019s ancient association with sobriety and clear sight complements the Water Bearer\u2019s drive to see beyond convention."},
Pisces:{d:"Feb 19 \u2013 Mar 20",e:"Water",s:"\u2653",x:"For Pisces, amethyst deepens natural intuition and spiritual sensitivity while providing protective clarity against emotional overwhelm. The stone\u2019s connection to inner peace and insight resonates with Pisces\u2019 empathic and imaginative nature."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-feb-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-feb-cal-btn';b.type='button';b.setAttribute('aria-label','February '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Pisces'){var dot=document.createElement('span');dot.className='pi-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-feb-cal-title'),eE=document.getElementById('ts-feb-cal-empty'),eC=document.getElementById('ts-feb-cal-card'),
eY=document.getElementById('ts-feb-cc-eye'),eB=document.getElementById('ts-feb-cc-badge'),eBS=document.getElementById('ts-feb-cc-bs'),
eZL=document.getElementById('ts-feb-cc-zl'),eZT=document.getElementById('ts-feb-cc-zt'),eF=document.getElementById('ts-feb-cc-fn'),
eTr=document.getElementById('ts-feb-cc-trait'),eCta=document.getElementById('ts-feb-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your February Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>February '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='February '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>February '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">amethyst</strong> \u2014 a gem of clarity, royalty, and inner strength. As '+(/^[aeiou]/i.test(d.z)?'an ':'a ')+d.z+' ('+z.d+'), amethyst is especially aligned with your sign.';
eZL.textContent=d.z+' + Amethyst';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop February '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    const megaImgRaw = "{{mega_img_file}}";
    const megaImgSplit = megaImgRaw.split(/[,]/).map(col => col.replace(/[\"\s{}]/g, '')).map(s => s.split('.'));
    const megaImgJSON = Object.fromEntries(megaImgSplit);
    const megaLink = "{{sample_img}}";
    window.onload = function () {
    const megaImage = document.querySelectorAll('.megaLinkImage');
    megaImage.forEach(function(image) {
    for(const img in megaImgJSON) {
    const imageBox = document.querySelector('[data-mega-image="${img}"]');
    if (image.dataset.megaImage == img) {
    const imgUrl = '${[img]}.${megaImgJSON[img]}'
    const assetImgUrl = megaLink.split('?')[0] + '${imgUrl}';
    imageBox.insertAdjacentHTML('beforeend',
    '<img src="${assetImgUrl}" >');}}
    })
    } 
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
     // this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      //this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      //this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      //this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      //this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      //this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      //this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["january-birthstone-garnet"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-jan-rv').forEach(function(el){obs.observe(el);});


document.querySelectorAll('.ts-jan-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-jan-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});


var sL=document.querySelectorAll('.ts-jan-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Capricorn",f:"J.D. Salinger",t:"Reclusive brilliance"},{day:2,z:"Capricorn",f:"Isaac Asimov",t:"Boundless imagination"},
{day:3,z:"Capricorn",f:"J.R.R. Tolkien",t:"World builder"},{day:4,z:"Capricorn",f:"Isaac Newton",t:"Relentless inquiry"},
{day:5,z:"Capricorn",f:"Diane Keaton",t:"Unconventional charm"},{day:6,z:"Capricorn",f:"Joan of Arc",t:"Fearless conviction"},
{day:7,z:"Capricorn",f:"Nicolas Cage",t:"Unbridled intensity"},{day:8,z:"Capricorn",f:"David Bowie",t:"Eternal reinvention"},
{day:9,z:"Capricorn",f:"Simone de Beauvoir",t:"Radical independence"},{day:10,z:"Capricorn",f:"Rod Stewart",t:"Enduring swagger"},
{day:11,z:"Capricorn",f:"Alexander Hamilton",t:"Relentless ambition"},{day:12,z:"Capricorn",f:"Jeff Bezos",t:"Obsessive vision"},
{day:13,z:"Capricorn",f:"Orlando Bloom",t:"Quiet magnetism"},{day:14,z:"Capricorn",f:"LL Cool J",t:"Focused power"},
{day:15,z:"Capricorn",f:"Martin Luther King Jr.",t:"Unyielding justice"},{day:16,z:"Capricorn",f:"Kate Moss",t:"Effortless edge"},
{day:17,z:"Capricorn",f:"Muhammad Ali",t:"Supreme confidence"},{day:18,z:"Capricorn",f:"Cary Grant",t:"Polished authority"},
{day:19,z:"Capricorn",f:"Edgar Allan Poe",t:"Dark artistry"},{day:20,z:"Aquarius",f:"Buzz Aldrin",t:"Pioneer spirit"},
{day:21,z:"Aquarius",f:"Christian Dior",t:"Visionary elegance"},{day:22,z:"Aquarius",f:"Lord Byron",t:"Romantic rebellion"},
{day:23,z:"Aquarius",f:"\u00c9douard Manet",t:"Breaking convention"},{day:24,z:"Aquarius",f:"Hadrian",t:"Imperial vision"},
{day:25,z:"Aquarius",f:"Virginia Woolf",t:"Interior depth"},{day:26,z:"Aquarius",f:"Ellen DeGeneres",t:"Disarming candor"},
{day:27,z:"Aquarius",f:"Wolfgang Amadeus Mozart",t:"Divine instinct"},{day:28,z:"Aquarius",f:"Jackson Pollock",t:"Controlled chaos"},
{day:29,z:"Aquarius",f:"Oprah Winfrey",t:"Transformative force"},{day:30,z:"Aquarius",f:"Franklin D. Roosevelt",t:"Steady resolve"},
{day:31,z:"Aquarius",f:"Justin Timberlake",t:"Versatile showman"}];
var Z={Capricorn:{d:"Dec 22 \u2013 Jan 19",e:"Earth",s:"\u2651",x:"Garnet amplifies Capricorn\u2019s natural discipline and quiet ambition. As an earth sign ruled by Saturn, Capricorn values endurance and structure \u2014 qualities garnet has symbolized since warriors first carried it into battle."},
Aquarius:{d:"Jan 20 \u2013 Feb 18",e:"Air",s:"\u2652",x:"For Aquarius, garnet provides emotional warmth and protective grounding to balance the Water Bearer\u2019s visionary nature. The stone\u2019s ancient association with safe passage and loyalty complements Aquarius\u2019s drive toward innovation with a steady, human center."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-jan-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-jan-cal-btn';b.type='button';b.setAttribute('aria-label','January '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Aquarius'){var dot=document.createElement('span');dot.className='aq-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-jan-cal-title'),eE=document.getElementById('ts-jan-cal-empty'),eC=document.getElementById('ts-jan-cal-card'),
eY=document.getElementById('ts-jan-cc-eye'),eB=document.getElementById('ts-jan-cc-badge'),eBS=document.getElementById('ts-jan-cc-bs'),
eZL=document.getElementById('ts-jan-cc-zl'),eZT=document.getElementById('ts-jan-cc-zt'),eF=document.getElementById('ts-jan-cc-fn'),
eTr=document.getElementById('ts-jan-cc-trait'),eCta=document.getElementById('ts-jan-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your January Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>January '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='January '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>January '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">garnet</strong> \u2014 a gem of protection, devotion, and inner fire. As a '+d.z+' ('+z.d+'), garnet is especially aligned with your sign.';
eZL.textContent=d.z+' + Garnet';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop January '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["july-birthstone-ruby"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-jul-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-jul-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-jul-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-jul-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Cancer",f:"Princess Diana",t:"Luminous rebellion"},{day:2,z:"Cancer",f:"Thurgood Marshall",t:"Justice forged"},
{day:3,z:"Cancer",f:"Tom Cruise",t:"Relentless intensity"},{day:4,z:"Cancer",f:"Calvin Coolidge",t:"Silent authority"},
{day:5,z:"Cancer",f:"P.T. Barnum",t:"Grand spectacle"},{day:6,z:"Cancer",f:"Frida Kahlo",t:"Pain into art"},
{day:7,z:"Cancer",f:"Ringo Starr",t:"Steady heartbeat"},{day:8,z:"Cancer",f:"John D. Rockefeller",t:"Empire builder"},
{day:9,z:"Cancer",f:"Tom Hanks",t:"Everyman genius"},{day:10,z:"Cancer",f:"Nikola Tesla",t:"Electric vision"},
{day:11,z:"Cancer",f:"Giorgio Armani",t:"Effortless precision"},{day:12,z:"Cancer",f:"Malala Yousafzai",t:"Fearless voice"},
{day:13,z:"Cancer",f:"Harrison Ford",t:"Reluctant hero"},{day:14,z:"Cancer",f:"Ingmar Bergman",t:"Existential depth"},
{day:15,z:"Cancer",f:"Rembrandt",t:"Light from shadow"},{day:16,z:"Cancer",f:"Will Ferrell",t:"Unhinged comedy"},
{day:17,z:"Cancer",f:"Angela Merkel",t:"Calculated patience"},{day:18,z:"Cancer",f:"Nelson Mandela",t:"Enduring justice"},
{day:19,z:"Cancer",f:"Edgar Degas",t:"Movement captured"},{day:20,z:"Cancer",f:"Carlos Santana",t:"Spiritual groove"},
{day:21,z:"Cancer",f:"Ernest Hemingway",t:"Brutal economy"},{day:22,z:"Cancer",f:"Alex Trebek",t:"Curious authority"},
{day:23,z:"Leo",f:"Daniel Radcliffe",t:"Magical persistence"},{day:24,z:"Leo",f:"Amelia Earhart",t:"Boundless courage"},
{day:25,z:"Leo",f:"Matt LeBlanc",t:"Effortless charm"},{day:26,z:"Leo",f:"Mick Jagger",t:"Eternal swagger"},
{day:27,z:"Leo",f:"Maya Rudolph",t:"Versatile spark"},{day:28,z:"Leo",f:"Beatrix Potter",t:"Gentle rebellion"},
{day:29,z:"Leo",f:"Wil Wheaton",t:"Enduring sincerity"},{day:30,z:"Leo",f:"Arnold Schwarzenegger",t:"Unstoppable will"},
{day:31,z:"Leo",f:"J.K. Rowling",t:"World architect"}];
var Z={Cancer:{d:"Jun 21 \u2013 Jul 22",e:"Water",s:"\u264b",x:"Ruby brings fire to Cancer\u2019s deep emotional nature. The stone\u2019s ancient associations with protection and the life force of blood resonate with the Crab\u2019s fierce instinct to protect those it loves."},
Leo:{d:"Jul 23 \u2013 Aug 22",e:"Fire",s:"\u264c",x:"Ruby is Leo\u2019s stone in every sense \u2014 the king of gems for the king of the zodiac. Bold, radiant, impossible to overlook. Both ruby and Leo demand to be seen."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-jul-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-jul-cal-btn';b.type='button';b.setAttribute('aria-label','July '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Leo'){var dot=document.createElement('span');dot.className='le-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-jul-cal-title'),eE=document.getElementById('ts-jul-cal-empty'),eC=document.getElementById('ts-jul-cal-card'),
eY=document.getElementById('ts-jul-cc-eye'),eB=document.getElementById('ts-jul-cc-badge'),eBS=document.getElementById('ts-jul-cc-bs'),
eZL=document.getElementById('ts-jul-cc-zl'),eZT=document.getElementById('ts-jul-cc-zt'),eF=document.getElementById('ts-jul-cc-fn'),
eTr=document.getElementById('ts-jul-cc-trait'),eCta=document.getElementById('ts-jul-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your July Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>July '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='July '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>July '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">ruby</strong> \u2014 ratnaraj, the king of precious stones. As a '+d.z+' ('+z.d+'), ruby is especially aligned with your sign.';
eZL.textContent=d.z+' + Ruby';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop July '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["june-birthstone-alexandrite"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-alex-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-alex-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-alex-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-alex-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["june-birthstone-pearl"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-jun-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-jun-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-jun-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-jun-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Gemini",f:"Marilyn Monroe",t:"Luminous contradictions"},{day:2,z:"Gemini",f:"Thomas Hardy",t:"Rural intensity"},
{day:3,z:"Gemini",f:"Rafael Nadal",t:"Relentless precision"},{day:4,z:"Gemini",f:"Angelina Jolie",t:"Fierce compassion"},
{day:5,z:"Gemini",f:"Mark Wahlberg",t:"Reinvention engine"},{day:6,z:"Gemini",f:"Alexander Pushkin",t:"Russian fire"},
{day:7,z:"Gemini",f:"Prince",t:"Purple sovereignty"},{day:8,z:"Gemini",f:"Frank Lloyd Wright",t:"Organic ambition"},
{day:9,z:"Gemini",f:"Johnny Depp",t:"Shape-shifting depth"},{day:10,z:"Gemini",f:"Judy Garland",t:"Devastating talent"},
{day:11,z:"Gemini",f:"Jacques Cousteau",t:"Ocean devotion"},{day:12,z:"Gemini",f:"Anne Frank",t:"Unbreakable hope"},
{day:13,z:"Gemini",f:"W.B. Yeats",t:"Mythic vision"},{day:14,z:"Gemini",f:"Che Guevara",t:"Revolutionary conviction"},
{day:15,z:"Gemini",f:"Courteney Cox",t:"Understated timing"},{day:16,z:"Gemini",f:"Tupac Shakur",t:"Poetic defiance"},
{day:17,z:"Gemini",f:"Venus Williams",t:"Blazing power"},{day:18,z:"Gemini",f:"Paul McCartney",t:"Melodic genius"},
{day:19,z:"Gemini",f:"Blaise Pascal",t:"Mathematical clarity"},{day:20,z:"Gemini",f:"Nicole Kidman",t:"Commanding range"},
{day:21,z:"Cancer",f:"Prince William",t:"Measured duty"},{day:22,z:"Cancer",f:"Meryl Streep",t:"Total transformation"},
{day:23,z:"Cancer",f:"Alan Turing",t:"Code-breaking brilliance"},{day:24,z:"Cancer",f:"Lionel Messi",t:"Supernatural instinct"},
{day:25,z:"Cancer",f:"George Orwell",t:"Prophetic clarity"},{day:26,z:"Cancer",f:"Ariana Grande",t:"Vocal force"},
{day:27,z:"Cancer",f:"Helen Keller",t:"Unconquerable will"},{day:28,z:"Cancer",f:"Elon Musk",t:"Obsessive scale"},
{day:29,z:"Cancer",f:"Antoine de Saint-Exup\u00e9ry",t:"Poetic flight"},{day:30,z:"Cancer",f:"Mike Tyson",t:"Raw power"}];
var Z={Gemini:{d:"May 21 \u2013 Jun 20",e:"Air",s:"\u264a",x:"Pearl grounds Gemini\u2019s restless duality with calm and emotional clarity. The twin shells that form a pearl mirror the Twins\u2019 nature \u2014 two halves creating something whole and luminous."},
Cancer:{d:"Jun 21 \u2013 Jul 22",e:"Water",s:"\u264b",x:"Pearl is Cancer\u2019s natural stone. Both born from the sea. Both connected to the moon. Both quietly protective. No birthstone-sign pairing in the zodiac runs deeper than this one."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-jun-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-jun-cal-btn';b.type='button';b.setAttribute('aria-label','June '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Cancer'){var dot=document.createElement('span');dot.className='cn-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-jun-cal-title'),eE=document.getElementById('ts-jun-cal-empty'),eC=document.getElementById('ts-jun-cal-card'),
eY=document.getElementById('ts-jun-cc-eye'),eB=document.getElementById('ts-jun-cc-badge'),eBS=document.getElementById('ts-jun-cc-bs'),
eZL=document.getElementById('ts-jun-cc-zl'),eZT=document.getElementById('ts-jun-cc-zt'),eF=document.getElementById('ts-jun-cc-fn'),
eTr=document.getElementById('ts-jun-cc-trait'),eCta=document.getElementById('ts-jun-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your June Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>June '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='June '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>June '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">pearl</strong> \u2014 the only gemstone born from a living creature. As a '+d.z+' ('+z.d+'), pearl is especially aligned with your sign.';
eZL.textContent=d.z+' + Pearl';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop June '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-grown-alexandrite-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-lga-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-lga-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-lga-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-lga-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-grown-diamond-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-lgd-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-lgd-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-lgd-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-lgd-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-grown-moissanite-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-moi-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-moi-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-moi-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-moi-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-grown-sapphire-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-lgs-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-lgs-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-lgs-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-lgs-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["march-birthstone-aquamarine"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-mar-rv').forEach(function(el){obs.observe(el);});


document.querySelectorAll('.ts-mar-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-mar-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});


var sL=document.querySelectorAll('.ts-mar-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Pisces",f:"Fr\u00e9d\u00e9ric Chopin",t:"Romantic intensity"},{day:2,z:"Pisces",f:"Dr. Seuss",t:"Playful genius"},
{day:3,z:"Pisces",f:"Alexander Graham Bell",t:"Inventive spark"},{day:4,z:"Pisces",f:"Antonio Vivaldi",t:"Seasonal mastery"},
{day:5,z:"Pisces",f:"Rosa Luxemburg",t:"Radical conviction"},{day:6,z:"Pisces",f:"Michelangelo",t:"Divine craft"},
{day:7,z:"Pisces",f:"Rachel Weisz",t:"Commanding depth"},{day:8,z:"Pisces",f:"Kat Von D",t:"Artistic edge"},
{day:9,z:"Pisces",f:"Yuri Gagarin",t:"First beyond"},{day:10,z:"Pisces",f:"Harriet Tubman",t:"Fearless liberation"},
{day:11,z:"Pisces",f:"Douglas Adams",t:"Cosmic wit"},{day:12,z:"Pisces",f:"Jack Kerouac",t:"Restless soul"},
{day:13,z:"Pisces",f:"William H. Macy",t:"Quiet resilience"},{day:14,z:"Pisces",f:"Albert Einstein",t:"Reimagining reality"},
{day:15,z:"Pisces",f:"Ruth Bader Ginsburg",t:"Steady justice"},{day:16,z:"Pisces",f:"Lauren Graham",t:"Quick-witted warmth"},
{day:17,z:"Pisces",f:"Nat King Cole",t:"Velvet authority"},{day:18,z:"Pisces",f:"Queen Latifah",t:"Regal versatility"},
{day:19,z:"Pisces",f:"Bruce Willis",t:"Understated grit"},{day:20,z:"Pisces",f:"Fred Rogers",t:"Gentle revolution"},
{day:21,z:"Aries",f:"Johann Sebastian Bach",t:"Architectural genius"},{day:22,z:"Aries",f:"Andrew Lloyd Webber",t:"Theatrical ambition"},
{day:23,z:"Aries",f:"Akira Kurosawa",t:"Visual poetry"},{day:24,z:"Aries",f:"Harry Houdini",t:"Escape artist"},
{day:25,z:"Aries",f:"Aretha Franklin",t:"Commanding soul"},{day:26,z:"Aries",f:"Diana Ross",t:"Supreme presence"},
{day:27,z:"Aries",f:"Quentin Tarantino",t:"Cinematic chaos"},{day:28,z:"Aries",f:"Lady Gaga",t:"Fearless reinvention"},
{day:29,z:"Aries",f:"Elle Macpherson",t:"Effortless power"},{day:30,z:"Aries",f:"Vincent van Gogh",t:"Turbulent beauty"},
{day:31,z:"Aries",f:"C\u00e9sar Ch\u00e1vez",t:"Quiet revolution"}];
var Z={Pisces:{d:"Feb 19 \u2013 Mar 20",e:"Water",s:"\u2653",x:"Aquamarine deepens Pisces\u2019 natural connection to intuition, emotional depth, and the healing power of the sea. As a water sign ruled by Neptune, Pisces and aquamarine share the same element \u2014 a perfect alignment of stone and sign."},
Aries:{d:"Mar 21 \u2013 Apr 19",e:"Fire",s:"\u2648",x:"For Aries, aquamarine tempers bold fire-sign energy with clarity and calm. The stone\u2019s ancient reputation for clear-sightedness and safe passage complements the Ram\u2019s courage with the wisdom to navigate wisely."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-mar-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-mar-cal-btn';b.type='button';b.setAttribute('aria-label','March '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Aries'){var dot=document.createElement('span');dot.className='ar-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-mar-cal-title'),eE=document.getElementById('ts-mar-cal-empty'),eC=document.getElementById('ts-mar-cal-card'),
eY=document.getElementById('ts-mar-cc-eye'),eB=document.getElementById('ts-mar-cc-badge'),eBS=document.getElementById('ts-mar-cc-bs'),
eZL=document.getElementById('ts-mar-cc-zl'),eZT=document.getElementById('ts-mar-cc-zt'),eF=document.getElementById('ts-mar-cc-fn'),
eTr=document.getElementById('ts-mar-cc-trait'),eCta=document.getElementById('ts-mar-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your March Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>March '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='March '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>March '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">aquamarine</strong> \u2014 the sailor\u2019s gem of calm, clarity, and courage. As a '+d.z+' ('+z.d+'), aquamarine is especially aligned with your sign.';
eZL.textContent=d.z+' + Aquamarine';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop March '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["may-birthstone-emerald"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-may__rv').forEach(function(el){obs.observe(el);});


document.querySelectorAll('.ts-may__faq-q').forEach(function(b){b.addEventListener('click',function(){var item=b.parentElement,isOpen=item.classList.contains('open');document.querySelectorAll('.ts-may__faq-item.open').forEach(function(i){i.classList.remove('open');});if(!isOpen)item.classList.add('open');});});


var sLinks=document.querySelectorAll('.ts-may__sb-nav a'),sects=[];
sLinks.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sects.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var cur=sects[0];for(var i=0;i<sects.length;i++){if(window.scrollY>=sects[i].el.offsetTop-200)cur=sects[i];}sLinks.forEach(function(l){l.classList.remove('active');});if(cur)cur.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Taurus",famous:"Wes Anderson",trait:"Grounded visionary"},{day:2,z:"Taurus",famous:"Dwayne Johnson",trait:"Unstoppable drive"},
{day:3,z:"Taurus",famous:"James Brown",trait:"Magnetic intensity"},{day:4,z:"Taurus",famous:"Audrey Hepburn",trait:"Effortless elegance"},
{day:5,z:"Taurus",famous:"Adele",trait:"Emotional depth"},{day:6,z:"Taurus",famous:"George Clooney",trait:"Composed charisma"},
{day:7,z:"Taurus",famous:"Eva Per\u00f3n",trait:"Fierce devotion"},{day:8,z:"Taurus",famous:"Enrique Iglesias",trait:"Passionate intensity"},
{day:9,z:"Taurus",famous:"Billy Joel",trait:"Poetic resilience"},{day:10,z:"Taurus",famous:"Bono",trait:"Unwavering conviction"},
{day:11,z:"Taurus",famous:"Salvador Dal\u00ed",trait:"Surreal imagination"},{day:12,z:"Taurus",famous:"Florence Nightingale",trait:"Quiet revolution"},
{day:13,z:"Taurus",famous:"Stevie Wonder",trait:"Joyful brilliance"},{day:14,z:"Taurus",famous:"Cate Blanchett",trait:"Commanding presence"},
{day:15,z:"Taurus",famous:"Madeleine Albright",trait:"Diplomatic strength"},{day:16,z:"Taurus",famous:"Janet Jackson",trait:"Self-reinvention"},
{day:17,z:"Taurus",famous:"Enya",trait:"Serene power"},{day:18,z:"Taurus",famous:"Tina Fey",trait:"Sharp intellect"},
{day:19,z:"Taurus",famous:"Malcolm X",trait:"Fearless truth"},{day:20,z:"Taurus",famous:"Cher",trait:"Unapologetic presence"},
{day:21,z:"Gemini",famous:"Notorious B.I.G.",trait:"Dual-edged expression"},{day:22,z:"Gemini",famous:"Naomi Campbell",trait:"Blazing individuality"},
{day:23,z:"Gemini",famous:"Joan Collins",trait:"Timeless confidence"},{day:24,z:"Gemini",famous:"Queen Victoria",trait:"Enduring legacy"},
{day:25,z:"Gemini",famous:"Miles Davis",trait:"Cool innovation"},{day:26,z:"Gemini",famous:"Lenny Kravitz",trait:"Eclectic soul"},
{day:27,z:"Gemini",famous:"Wild Bill Hickok",trait:"Untamed spirit"},{day:28,z:"Gemini",famous:"Ian Fleming",trait:"Sophisticated intrigue"},
{day:29,z:"Gemini",famous:"John F. Kennedy",trait:"Visionary leadership"},{day:30,z:"Gemini",famous:"Idina Menzel",trait:"Unleashed voice"},
{day:31,z:"Gemini",famous:"Clint Eastwood",trait:"Quiet authority"}
];
var ZOD={Taurus:{dates:"Apr 20 \u2013 May 20",element:"Earth",symbol:"\u2649",text:"Emerald amplifies Taurus\u2019s natural grounding energy \u2014 patience, loyalty, and deep appreciation for beauty. The stone\u2019s association with Venus, Taurus\u2019s ruling planet, makes it a uniquely powerful talisman for those born under the Bull."},
Gemini:{dates:"May 21 \u2013 Jun 20",element:"Air",symbol:"\u264a",text:"For Gemini, emerald channels intellectual clarity and eloquent communication. Ancient lore held that emerald could reveal truth and sharpen the mind, perfectly complementing Gemini\u2019s dual nature and communicative drive."}};


function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var grid=document.getElementById('ts-may-cal-grid'),btns=[],activeIdx=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-may__cal-btn';b.type='button';b.setAttribute('aria-label','May '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Gemini'){var dot=document.createElement('span');dot.className='gm-dot';b.appendChild(dot);}
b.addEventListener('click',function(){selectDay(i);});grid.appendChild(b);btns.push(b);});


var elTitle=document.getElementById('ts-may-cal-title'),elEmpty=document.getElementById('ts-may-cal-empty'),elCard=document.getElementById('ts-may-cal-card'),
elEye=document.getElementById('ts-mc-eye'),elBadge=document.getElementById('ts-mc-badge'),elBS=document.getElementById('ts-mc-bs'),
elZL=document.getElementById('ts-mc-zl'),elZT=document.getElementById('ts-mc-zt'),elF=document.getElementById('ts-mc-fn'),
elTr=document.getElementById('ts-mc-trait'),elCta=document.getElementById('ts-mc-cta');


function selectDay(i){
if(activeIdx===i){btns[i].classList.remove('is-active');activeIdx=-1;elEmpty.style.display='';elCard.style.display='none';elTitle.innerHTML='What Is the Birthstone for <em>Your May Birthday</em>?';return;}
if(activeIdx>=0)btns[activeIdx].classList.remove('is-active');activeIdx=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=ZOD[d.z],o=ord(d.day);
elTitle.innerHTML='What Is the Birthstone for <em>May '+o+'</em>?';
elEmpty.style.display='none';elCard.style.display='';elCard.style.animation='none';elCard.offsetHeight;elCard.style.animation='';
elEye.textContent='May '+o+' Birthstone';elBadge.textContent=z.symbol+' '+d.z+' \u00B7 '+z.element;
elBS.innerHTML='If you were born on <strong>May '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">emerald</strong> \u2014 a gem of renewal, love, and truth. As a '+d.z+' ('+z.dates+'), emerald is especially aligned with your sign.';
elZL.textContent=d.z+' + Emerald';elZT.textContent=z.text;elF.textContent=d.famous;elTr.textContent=d.trait;
elCta.textContent='Shop May '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)elCard.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morganite-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-mor-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-mor-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-mor-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-mor-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["november-birthstone-citrine"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-cit-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-cit-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-cit-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-cit-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["november-birthstone-topaz"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-nov-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-nov-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-nov-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-nov-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
var DAYS=[
{day:1,z:"Scorpio",f:"Tim Cook",t:"Quiet execution"},{day:2,z:"Scorpio",f:"Marie Antoinette",t:"Tragic opulence"},
{day:3,z:"Scorpio",f:"Anna Wintour",t:"Editorial power"},{day:4,z:"Scorpio",f:"Matthew McConaughey",t:"Alright alright"},
{day:5,z:"Scorpio",f:"Tilda Swinton",t:"Shapeshifting art"},{day:6,z:"Scorpio",f:"Emma Stone",t:"Disarming talent"},
{day:7,z:"Scorpio",f:"Marie Curie",t:"Radioactive brilliance"},{day:8,z:"Scorpio",f:"Gordon Ramsay",t:"Fiery standards"},
{day:9,z:"Scorpio",f:"Carl Sagan",t:"Cosmic wonder"},{day:10,z:"Scorpio",f:"Martin Luther",t:"95 theses"},
{day:11,z:"Scorpio",f:"Leonardo DiCaprio",t:"Method commitment"},{day:12,z:"Scorpio",f:"Ryan Gosling",t:"Understated cool"},
{day:13,z:"Scorpio",f:"Robert Louis Stevenson",t:"Adventure penned"},{day:14,z:"Scorpio",f:"Claude Monet",t:"Light captured"},
{day:15,z:"Scorpio",f:"Georgia O\u2019Keeffe",t:"Desert bloom"},{day:16,z:"Scorpio",f:"Shigeru Miyamoto",t:"Play invented"},
{day:17,z:"Scorpio",f:"Martin Scorsese",t:"Cinema\u2019s conscience"},{day:18,z:"Scorpio",f:"Owen Wilson",t:"Wry warmth"},
{day:19,z:"Scorpio",f:"Jodie Foster",t:"Fierce intelligence"},{day:20,z:"Scorpio",f:"Joe Biden",t:"Persistent return"},
{day:21,z:"Scorpio",f:"Voltaire",t:"Satirical genius"},
{day:22,z:"Sagittarius",f:"Scarlett Johansson",t:"Versatile gravity"},{day:23,z:"Sagittarius",f:"Miley Cyrus",t:"Perpetual reinvention"},
{day:24,z:"Sagittarius",f:"Dale Carnegie",t:"Winning friends"},{day:25,z:"Sagittarius",f:"Joe DiMaggio",t:"Graceful streak"},
{day:26,z:"Sagittarius",f:"Tina Turner",t:"Unstoppable force"},{day:27,z:"Sagittarius",f:"Bruce Lee",t:"Water philosophy"},
{day:28,z:"Sagittarius",f:"Jon Stewart",t:"Satirical integrity"},{day:29,z:"Sagittarius",f:"C.S. Lewis",t:"Wardrobe worlds"},
{day:30,z:"Sagittarius",f:"Mark Twain",t:"American tongue"}];
var Z={Scorpio:{d:"Oct 23 \u2013 Nov 21",e:"Water",s:"\u264f",x:"Imperial topaz\u2019s fire beneath a polished surface mirrors Scorpio\u2019s intensity. Both are warm beneath a composed exterior, and both reveal more the longer you look."},
Sagittarius:{d:"Nov 22 \u2013 Dec 21",e:"Fire",s:"\u2650",x:"Topaz\u2019s ancient association with strength and adventure aligns with Sagittarius\u2019s restless pursuit of truth, new horizons, and the kind of knowledge that can only come from experience."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-nov-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-nov-cal-btn';b.type='button';b.setAttribute('aria-label','November '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Sagittarius'){var dot=document.createElement('span');dot.className='sg-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-nov-cal-title'),eE=document.getElementById('ts-nov-cal-empty'),eC=document.getElementById('ts-nov-cal-card'),
eY=document.getElementById('ts-nov-cc-eye'),eB=document.getElementById('ts-nov-cc-badge'),eBS=document.getElementById('ts-nov-cc-bs'),
eZL=document.getElementById('ts-nov-cc-zl'),eZT=document.getElementById('ts-nov-cc-zt'),eF=document.getElementById('ts-nov-cc-fn'),
eTr=document.getElementById('ts-nov-cc-trait'),eCta=document.getElementById('ts-nov-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your November Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>November '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='November '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>November '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">topaz</strong> (with citrine as an alternative). As a '+d.z+' ('+z.d+'), topaz is especially aligned with your sign.';
eZL.textContent=d.z+' + Topaz';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop November '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["october-birthstone-tourmaline"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-tour-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-tour-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-tour-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-tour-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opal-gemstone-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-oct-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-oct-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-oct-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-oct-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});

var DAYS=[
{day:1,z:"Libra",f:"Julie Andrews",t:"Crystal clarity"},{day:2,z:"Libra",f:"Mahatma Gandhi",t:"Nonviolent revolution"},
{day:3,z:"Libra",f:"Gwen Stefani",t:"Genre refusal"},{day:4,z:"Libra",f:"Buster Keaton",t:"Stone-faced genius"},
{day:5,z:"Libra",f:"Kate Winslet",t:"Fearless depth"},{day:6,z:"Libra",f:"Le Corbusier",t:"Concrete poetry"},
{day:7,z:"Libra",f:"Desmond Tutu",t:"Joyful justice"},{day:8,z:"Libra",f:"Matt Damon",t:"Everyman range"},
{day:9,z:"Libra",f:"John Lennon",t:"Imagine that"},{day:10,z:"Libra",f:"Thelonious Monk",t:"Angular beauty"},
{day:11,z:"Libra",f:"Eleanor Roosevelt",t:"Quiet revolution"},{day:12,z:"Libra",f:"Hugh Jackman",t:"Magnetic range"},
{day:13,z:"Libra",f:"Margaret Thatcher",t:"Iron conviction"},{day:14,z:"Libra",f:"Usher",t:"Smooth precision"},
{day:15,z:"Libra",f:"Friedrich Nietzsche",t:"Beyond good and evil"},{day:16,z:"Libra",f:"Oscar Wilde",t:"Weaponized wit"},
{day:17,z:"Libra",f:"Eminem",t:"Verbal detonation"},{day:18,z:"Libra",f:"Chuck Berry",t:"Rock invented"},
{day:19,z:"Libra",f:"John le Carr\u00e9",t:"Cold-war architect"},{day:20,z:"Libra",f:"Snoop Dogg",t:"Laid-back empire"},
{day:21,z:"Libra",f:"Carrie Fisher",t:"Unfiltered royalty"},{day:22,z:"Libra",f:"Jeff Goldblum",t:"Eccentric magnetism"},
{day:23,z:"Scorpio",f:"Pel\u00e9",t:"Beautiful game"},{day:24,z:"Scorpio",f:"Drake",t:"Chart dominance"},
{day:25,z:"Scorpio",f:"Pablo Picasso",t:"Relentless reinvention"},{day:26,z:"Scorpio",f:"Hillary Clinton",t:"Persistent ambition"},
{day:27,z:"Scorpio",f:"Theodore Roosevelt",t:"Bull Moose energy"},{day:28,z:"Scorpio",f:"Bill Gates",t:"Systematic vision"},
{day:29,z:"Scorpio",f:"Bob Ross",t:"Happy little accidents"},{day:30,z:"Scorpio",f:"Diego Maradona",t:"Hand of God"},
{day:31,z:"Scorpio",f:"John Keats",t:"Beauty is truth"}];
var Z={Libra:{d:"Sep 23 \u2013 Oct 22",e:"Air",s:"\u264e",x:"Opal\u2019s shifting play-of-color mirrors Libra\u2019s ability to see every side of a situation. Both prize beauty, balance, and the art of holding contradictions gracefully."},
Scorpio:{d:"Oct 23 \u2013 Nov 21",e:"Water",s:"\u264f",x:"Opal\u2019s fire beneath the surface resonates with Scorpio\u2019s intensity and emotional depth. Both reveal more the closer you look, and both hold secrets that reward patience."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-oct-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-oct-cal-btn';b.type='button';b.setAttribute('aria-label','October '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Scorpio'){var dot=document.createElement('span');dot.className='sc-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-oct-cal-title'),eE=document.getElementById('ts-oct-cal-empty'),eC=document.getElementById('ts-oct-cal-card'),
eY=document.getElementById('ts-oct-cc-eye'),eB=document.getElementById('ts-oct-cc-badge'),eBS=document.getElementById('ts-oct-cc-bs'),
eZL=document.getElementById('ts-oct-cc-zl'),eZT=document.getElementById('ts-oct-cc-zt'),eF=document.getElementById('ts-oct-cc-fn'),
eTr=document.getElementById('ts-oct-cc-trait'),eCta=document.getElementById('ts-oct-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your October Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>October '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='October '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>October '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">opal</strong> (with tourmaline as a modern alternative). As a '+d.z+' ('+z.d+'), opal is especially aligned with your sign.';
eZL.textContent=d.z+' + Opal';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop October '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pink-sapphire-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-pks-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-pks-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-pks-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-pks-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
               let recommendationsToShow = 4
                const considerSlick = $('.also_consider_slick')
                const recommendationsProds= html.querySelectorAll('.grid__item')
                if ( $(window).width() < 491) recommendationsToShow =1
                if(recommendationsProds.length > recommendationsToShow){
                    $('.also_consider_next_btn').css("display", "block");
                    $('.also_consider_prev_btn').css("display", "block");
                    considerSlick.slick({
                        dots: false,
                        speed: 300,
                        infinite: false,
                        slidesToShow: recommendationsToShow,
                        adaptiveHeight: false,
                        arrows:true,
                        nextArrow: $('.also_consider_next_btn'),
                        prevArrow: $('.also_consider_prev_btn'),                
                        responsive: [
                        {
                        breakpoint:1000,
                        settings: {
                            slidesToShow: 2
                        }
                        },
                        {
                        breakpoint: 492,
                        settings: {
                            slidesToShow: 2.5
                         
                        }
                        },
                            {
                        breakpoint: 320,
                        settings: {
                            slidesToShow: 2.5
                            
                        }
                        }
                    ]
                    });
                }else{
                    considerSlick.addClass('also_consider_noslick')
                }
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salt-pepper-diamonds-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-sp-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-sp-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-sp-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-sp-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["september-birthstone-sapphire"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.1,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.ts-sep-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-sep-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-sep-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-sep-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});


var DAYS=[
{day:1,z:"Virgo",f:"Gloria Estefan",t:"Rhythmic resilience"},{day:2,z:"Virgo",f:"Keanu Reeves",t:"Quiet kindness"},
{day:3,z:"Virgo",f:"Charlie Sheen",t:"Unfiltered energy"},{day:4,z:"Virgo",f:"Beyonc\u00e9",t:"Total dominance"},
{day:5,z:"Virgo",f:"Freddie Mercury",t:"Boundless voice"},{day:6,z:"Virgo",f:"Idris Elba",t:"Commanding cool"},
{day:7,z:"Virgo",f:"Buddy Holly",t:"Rock pioneer"},{day:8,z:"Virgo",f:"Pink",t:"Fearless honesty"},
{day:9,z:"Virgo",f:"Adam Sandler",t:"Comedic loyalty"},{day:10,z:"Virgo",f:"Guy Ritchie",t:"Stylish chaos"},
{day:11,z:"Virgo",f:"Ludacris",t:"Southern swagger"},{day:12,z:"Virgo",f:"Yao Ming",t:"Towering grace"},
{day:13,z:"Virgo",f:"Roald Dahl",t:"Dark wonder"},{day:14,z:"Virgo",f:"Amy Winehouse",t:"Reckless genius"},
{day:15,z:"Virgo",f:"Agatha Christie",t:"Mystery architect"},{day:16,z:"Virgo",f:"B.B. King",t:"Blues sovereign"},
{day:17,z:"Virgo",f:"Baz Luhrmann",t:"Visual excess"},{day:18,z:"Virgo",f:"Greta Garbo",t:"Glamorous solitude"},
{day:19,z:"Virgo",f:"Twiggy",t:"Iconic simplicity"},{day:20,z:"Virgo",f:"Sophia Loren",t:"Italian fire"},
{day:21,z:"Virgo",f:"Stephen King",t:"Relentless nightmares"},{day:22,z:"Virgo",f:"Andrea Bocelli",t:"Voice without limits"},
{day:23,z:"Libra",f:"Bruce Springsteen",t:"Working-class thunder"},{day:24,z:"Libra",f:"F. Scott Fitzgerald",t:"Jazz Age elegance"},
{day:25,z:"Libra",f:"Will Smith",t:"Crossover king"},{day:26,z:"Libra",f:"Serena Williams",t:"Unmatched force"},
{day:27,z:"Libra",f:"Lil Wayne",t:"Lyrical wildfire"},{day:28,z:"Libra",f:"Confucius",t:"Enduring wisdom"},
{day:29,z:"Libra",f:"Lech Wa\u0142\u0119sa",t:"Solidarity forged"},{day:30,z:"Libra",f:"Truman Capote",t:"Cold-blooded prose"}];
var Z={Virgo:{d:"Aug 23 \u2013 Sep 22",e:"Earth",s:"\u264d",x:"Sapphire\u2019s centuries-old association with wisdom, precision, and clear thinking aligns naturally with Virgo\u2019s analytical mind and quiet perfectionism. The stone sharpens what Virgo already does best."},
Libra:{d:"Sep 23 \u2013 Oct 22",e:"Air",s:"\u264e",x:"Sapphire\u2019s symbolism of loyalty, justice, and truth resonates with Libra\u2019s instinct for fairness. The stone brings clarity to the Scales\u2019 lifelong pursuit of balance in all things."}};
function ord(n){var s=["th","st","nd","rd"],v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);}
var g=document.getElementById('ts-sep-cal-grid'),btns=[],ai=-1;
DAYS.forEach(function(d,i){var b=document.createElement('button');b.className='ts-sep-cal-btn';b.type='button';b.setAttribute('aria-label','September '+ord(d.day)+' birthstone');b.textContent=d.day;
if(d.z==='Libra'){var dot=document.createElement('span');dot.className='lb-dot';b.appendChild(dot);}
b.addEventListener('click',function(){sel(i);});g.appendChild(b);btns.push(b);});
var eT=document.getElementById('ts-sep-cal-title'),eE=document.getElementById('ts-sep-cal-empty'),eC=document.getElementById('ts-sep-cal-card'),
eY=document.getElementById('ts-sep-cc-eye'),eB=document.getElementById('ts-sep-cc-badge'),eBS=document.getElementById('ts-sep-cc-bs'),
eZL=document.getElementById('ts-sep-cc-zl'),eZT=document.getElementById('ts-sep-cc-zt'),eF=document.getElementById('ts-sep-cc-fn'),
eTr=document.getElementById('ts-sep-cc-trait'),eCta=document.getElementById('ts-sep-cc-cta-link');
function sel(i){
if(ai===i){btns[i].classList.remove('is-active');ai=-1;eE.style.display='';eC.style.display='none';eT.innerHTML='What Is the Birthstone for <em>Your September Birthday</em>?';return;}
if(ai>=0)btns[ai].classList.remove('is-active');ai=i;btns[i].classList.add('is-active');
var d=DAYS[i],z=Z[d.z],o=ord(d.day);
eT.innerHTML='What Is the Birthstone for <em>September '+o+'</em>?';
eE.style.display='none';eC.style.display='';eC.style.animation='none';eC.offsetHeight;eC.style.animation='';
eY.textContent='September '+o+' Birthstone';eB.textContent=z.s+' '+d.z+' \u00B7 '+z.e;
eBS.innerHTML='If you were born on <strong>September '+o+'</strong>, your birthstone is <strong style="color:var(--gg)">sapphire</strong>, the stone of wisdom and loyalty. As a '+d.z+' ('+z.d+'), sapphire is especially aligned with your sign.';
eZL.textContent=d.z+' + Sapphire';eZT.textContent=z.x;eF.textContent=d.f;eTr.textContent=d.t;
eCta.textContent='Shop September '+o+' Birthstone Jewelry \u2192';
if(window.innerWidth<768)eC.scrollIntoView({behavior:'smooth',block:'nearest'});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yellow-canary-diamonds-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting)en.target.classList.add('visible');});},{threshold:.08,rootMargin:'0px 0px -80px 0px'});
document.querySelectorAll('.ts-yd-rv').forEach(function(el){obs.observe(el);});
document.querySelectorAll('.ts-yd-faq-q').forEach(function(b){b.addEventListener('click',function(){var i=b.parentElement,o=i.classList.contains('open');document.querySelectorAll('.ts-yd-faq-item.open').forEach(function(x){x.classList.remove('open');});if(!o)i.classList.add('open');});});
var sL=document.querySelectorAll('.ts-yd-sbnav a'),sc=[];
sL.forEach(function(l){var id=l.getAttribute('href');if(id){var el=document.querySelector(id);if(el)sc.push({el:el,link:l});}});
window.addEventListener('scroll',function(){var c=sc[0];for(var i=0;i<sc.length;i++){if(window.scrollY>=sc[i].el.offsetTop-200)c=sc[i];}sL.forEach(function(l){l.classList.remove('active');});if(c)c.link.classList.add('active');},{passive:true});
})();

  } catch(e) { console.error(e); }
})();
})();
